// require("dotenv").config({
//   path: `.env.${env}`,
// })

module.exports = {
  siteMetadata: {
    title: `BugZero`,
    author: "BugZero",
    description: `Instead of hunting for the operational bugs that pose a risk to your infrastructure, BugZero brings them directly into where you’re already working today – your ITSM tool.`,
    social: {
      linkedin: "https://www.linkedin.com/company/findbugzero",
      twitter: "https://twitter.com/findbugzero",
      twitterUsername: "@findbugzero",
    },
    twitterUsername: `@findbugzero`,
    image: `./static/share-card.png`,
    siteUrl: `https://www.findbugzero.com`,
  },
  plugins: [
    `gatsby-plugin-layout`,
    "gatsby-plugin-image",
    "gatsby-plugin-react-helmet",
    "gatsby-plugin-robots-txt",
    "gatsby-plugin-sitemap",
    // "flowbite-react",
    {
      resolve: "gatsby-plugin-manifest",
      options: {
        icon: "./static/bz-favicon.png",
        background_color: `#222`,
      },
    },
    {
      resolve: `gatsby-source-contentful`,
      options: {
        spaceId: `67ncrdo24cds`,
        accessToken: "va8yEZBq4OpG0xzH7iWx-yDSyCRPRzSkuHo0w7YriWk",
      },
    },
    "gatsby-plugin-sharp",
    "gatsby-transformer-sharp",
    {
      resolve: "gatsby-source-filesystem",
      options: {
        name: "images",
        path: "./src/images/",
      },
      __key: "images",
    },
    {
      resolve: `gatsby-plugin-s3`,
      options: {
        bucketName: "website.findbugzero.com",
      },
    },
    "gatsby-plugin-postcss",
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        trackingIds: ["G-JDC008G9BG"],
        gtagConfig: {
          optimize_id: "OPT_CONTAINER_ID",
          anonymize_ip: false,
          cookie_expires: 0,
        },
        pluginConfig: {
          // Tracking script in the head or body
          head: false,
          respectDNT: false,
          // Avoids sending pageview hits from custom paths
          // exclude: ["/preview/**", "/do-not-track/me/too/"],
          // Defaults to https://www.googletagmanager.com
          origin: "https://www.googletagmanager.com",
        },
      },
    },
  ],
};
